import React from "react";
import {
  VStack,
  Heading,
  Container,
  Text,
  List,
  Link,
  ListItem,
} from "@chakra-ui/react";
import { Link as ReactRouterLink } from "react-router-dom";

import {
  StepImage,
  StepsAny,
  getPartTypeFromSerialNumber,
  getHumanReadableStepName,
} from "@constants";
import { ImagePopUp } from "@components";

type EventBodyProps = {
  comments: string;
  relatedSerials: string[];
  extraData: { name: string; data: string }[];
  imageData: StepImage;
  stepName: StepsAny;
};

export function EventBody({
  comments,
  relatedSerials,
  extraData,
  imageData,
  stepName,
}: EventBodyProps) {
  return (
    <VStack alignItems="stretch">
      <Heading as="h5" size="sm">
        Comments
      </Heading>
      <Text>{comments}</Text>
      {relatedSerials.length > 0 ? (
        <>
          <Heading as="h5" size="sm">
            Related Serials
          </Heading>
          <Container>
            <List>
              {relatedSerials.map((serial) => (
                <ListItem key={serial}>
                  <Link
                    as={ReactRouterLink}
                    to={`component/${serial}`}
                    display="flex"
                    flexDir="row"
                    gap="4px"
                  >
                    <Text as="strong">
                      {getPartTypeFromSerialNumber(serial).shorthand}:
                    </Text>
                    {" " + serial}
                  </Link>
                </ListItem>
              ))}
            </List>
          </Container>
        </>
      ) : undefined}
      {extraData.length > 0 ? (
        <>
          <Heading as="h5" size="sm">
            Extra Data
          </Heading>
          <Container>
            <List>
              {extraData.map(({ name, data }) => (
                <ListItem key={name} display="flex" flexDir="row" gap="4px">
                  <Text as="strong">{name}:</Text>
                  <Text>{" " + data}</Text>
                </ListItem>
              ))}
            </List>
          </Container>
        </>
      ) : null}
      {imageData.src && imageData.alt ? (
        <ImagePopUp
          src={imageData.src}
          title={getHumanReadableStepName(stepName)}
          comments={imageData.alt}
        />
      ) : null}
    </VStack>
  );
}
